/* ==========================================================================
   oddit-section-ugc-carousel
   Scroll-driven progress bar for UGC carousel
   ========================================================================== */

(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-carousel';
  var sectionState = new Map();

  function initSection(section) {
    var track = section.querySelector('.oddit-section-ugc-carousel__track');
    var progressIndicator = section.querySelector('.oddit-section-ugc-carousel__progress-indicator');

    if (!track || !progressIndicator) return;

    /* Set initial minimum width to represent first visible portion */
    function setInitialProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        progressIndicator.style.width = '100%';
        return;
      }
      var visibleRatio = track.clientWidth / track.scrollWidth;
      var minWidth = Math.max(20, visibleRatio * 100);
      progressIndicator.style.width = minWidth + '%';
    }

    function handleScroll() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll <= 0) {
        progressIndicator.style.width = '100%';
        return;
      }

      /* Progress fills from visible-portion-width to 100% as user scrolls */
      var visibleRatio = track.clientWidth / track.scrollWidth;
      var minWidth = visibleRatio * 100;
      var scrollRatio = scrollLeft / maxScroll;
      var progressWidth = minWidth + scrollRatio * (100 - minWidth);
      progressIndicator.style.width = Math.max(20, progressWidth) + '%';
    }

    track.addEventListener('scroll', handleScroll, { passive: true });

    /* Size observer to recalculate on resize */
    var ro = new ResizeObserver(function () {
      setInitialProgress();
    });
    ro.observe(track);

    setInitialProgress();

    sectionState.set(section.id || section, {
      track: track,
      handleScroll: handleScroll,
      ro: ro
    });
  }

  function destroySection(section) {
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state) return;
    if (state.track && state.handleScroll) {
      state.track.removeEventListener('scroll', state.handleScroll);
    }
    if (state.ro) state.ro.disconnect();
    sectionState.delete(key);
  }

  /* Init all instances on page */
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
